// Type guard to verify application type
export const isSupportedApplication = (app) => {
    return app === 'wayste' || app === 'admin-portal';
};
//# sourceMappingURL=utils.js.map